import React from "react";
import CareerForm from "./CareerForm";
import CareerTable from "./CareerTable";
import ApplicationHeader from "../ApplicationHeader";

const CareerStep = (props) => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <p style={{ margin: 0 }}>
          Include career history for the past 5 years, including both Comcast and
          non-Comcast experience.
        </p>
        <CareerForm
          createCareer={props.createCareer}
          application={props.application}
          careerEntries={props.careerEntries}
          handleDeleteCareer={props.handleDeleteCareer}
          updateCareer={props.updateCareer}
        />
      </div>

      <CareerTable
        careerEntries={props.careerEntries}
      />
    </div>
  );
};

export default CareerStep;
